/* NATURAL 50 mm - 32 decors on the same 50 mm price grids (group 0 = NATURAL).
   They split into two families only because the maximum width differs per
   decor: 28 decors stop at 3000 mm, while 01, 10, 17 and 18 go to 3600.
   Both point at the same W.CT array, so the numbers can never drift apart.
   Minimum width is 450 mm - the C+T price list starts there; 400 mm exists
   only on the Retro system, which is not sold.
   Loads after naru-wood-50b.js. */
(function(){
var W=window.NARU_W50;
if(!W||!W.CT){return;}

function slats(list){return list.map(function(c){return {c:c,g:0};});}

window.NARU_W50N={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:slats(['02NM','03NM','04NM','05NM','06NM','09NM','11NM','12NM','13NM','15NM','16NM','19NM','22NM','23NM','28NM','30NM','31NM','33NM','34NM','61NM','62NM','63NM','64NM','68NM','69NM','70NM','90NM','91NM']),
  FAM:{id:'w50n',mat:'wood',sw:50,grps:[0,1,2,3,5],groups:0,w0:0.5,h0:0.3,lim:[450,3000,300,4000],stack:[55,65]}
};

window.NARU_W50NW={
  CT:W.CT,
  GRP:W.GRP,
  SLATS:slats(['01NM','10NM','17NM','18NM']),
  FAM:{id:'w50nw',mat:'wood',sw:50,grps:[0,1,2,3,5],groups:0,w0:0.5,h0:0.3,lim:[450,3600,300,4000],stack:[55,65]}
};
})();
